import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';

import { AuthorizationService, LOGOUT_DELAY } from '../../authorization/authorization.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	/* eslint-disable @typescript-eslint/no-explicit-any */
	constructor(private authService: AuthorizationService) {
	}

	public intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		return next.handle(request)
			.pipe(
				catchError(
					(httpError: any) => {
						if (httpError instanceof HttpErrorResponse) {
							// сессия просрочена
							if (httpError.status === 403) {
								// Задержка для показа сообщения пользователю
								setTimeout(() => {
									this.authService.logoutWithRedirectToLogin();
								}, LOGOUT_DELAY);
							}
						}
						return throwError(httpError);
					},
				),
			);
	}
}
